module.exports = __webpack_public_path__ + "img/logo_navbar.2fe5685a.png";